<template>
  <b-modal
    ref="bModal"
    :title="title"
    centered
    size="xs"
    modal-class="laboratory-devices-modal-form"
  >
    <b-row class="px-4">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <div>
          <div class="form-label">
            <label>{{ $tc('laboratory.tracking.selectElement') }}</label>
          </div>
          <vt-combo-select
            v-model="instrumentSelected"
            v-testing="'instrument'"
            class="nowrap"
            :options="devices"
            label="device"
            :placeholder="$tc('global.instrument')"
          />
        </div>
      </b-col>
    </b-row>

    <b-row class="px-4 mt-3">
      <b-col cols="12">
        <div class="d-flex justify-content-end align-items-center">
          <div>
            <span class="switch-title mr-2">{{ $tc('laboratory.content.fixElement') }}</span>
          </div>
          <div class="switch-btn p-0 d-flex align-items-center justify-content-center">
            <input
              id="fix-instrument-modal"
              v-model="instrumentFixed"
              v-testing="'fix-instrument-switch'"
              type="checkbox"
              class="offscreen"
              aria-hidden="true"
            >
            <label
              for="fix-instrument-modal"
              class="switch mb-0"
            />
          </div>
        </div>
      </b-col>

      <b-col
        class="mt-2"
        cols="12"
      >
        <div class="d-flex justify-content-end align-items-center">
          <div>
            <span class="switch-title mr-2">{{ $tc('laboratory.content.overwriteExisting') }}</span>
          </div>
          <div class="switch-btn p-0 d-flex align-items-center justify-content-center">
            <input
              id="overwrite-instrument-modal"
              v-model="instrumentOverwritten"
              v-testing="'overwrite-instrument-switch'"
              type="checkbox"
              class="offscreen"
              aria-hidden="true"
            >
            <label
              for="overwrite-instrument-modal"
              class="switch mb-0"
            />
          </div>
        </div>
      </b-col>
    </b-row>

    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            v-testing="'cancel'"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $tc('global.cancel') }}
          </b-button>
        </div>

        <div class="col-7 text-right">
          <b-button
            v-testing="'apply'"
            size="sm"
            class="btn--primary"
            :disabled="!modelValidated"
            @click="applyDevice(hide)"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $tc('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import instrumentsModalMixin from '@/modules/laboratoryModule/mixins/instrumentsModalMixin'

export default {
    name: 'LaboratoryDevicesModalForm',
    mixins: [
        instrumentsModalMixin
    ],
    methods: {
        show() {
            this.resetInstrumentsModalData()
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .laboratory-devices-modal-form .switch-title {
        font-size: font-size(very-small);
    }
    .laboratory-devices-modal-form .title {
        font-size: font-size(very-small) !important;
    }
    .laboratory-devices-modal-form .modal-body {
        padding: 20px 10px;
    }
    .laboratory-devices-modal-form .switch-label {
        font-size: font-size(very-small);
        color: vt-color(dark-text);
    }
    .laboratory-devices-modal-form .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 20px;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        transition: all 0.3s;
        cursor: pointer;
    }
    .laboratory-devices-modal-form .switch::after {
        content: "";
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius: 18px;
        background-color: white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }
    .laboratory-devices-modal-form input[type="checkbox"]:checked + .switch::after {
        transform: translateX(20px);
    }
    .laboratory-devices-modal-form input[type="checkbox"]:checked + .switch {
        background-color: vt-color(primary);
    }
    .laboratory-devices-modal-form .offscreen {
        position: absolute;
        left: -9999px;
    }
</style>
